import _ from 'lodash';
import React, { useMemo } from 'react';

import { useIsEventQuestionsLoaded } from '../../../../../data/hooks/questions/useIsEventQuestionsLoaded';
import { useEventQuestions } from '../../../../../data/hooks/questions/useEventQuestions';
import ListItem from '../../../../elements/DEPRECATED_ListItem';
import Link from '../../../../elements/Link';
import SectionLinkedHeader from '../../../../elements/SectionHeader/SectionLinkedHeader/SectionLinkedHeader';
import { isQAActive } from '../../../../../data/filters/questions/isQAActive';
import styles from './CommonEventQuests.module.scss';

const CommonEventQuests = (props) => {
    const { event, i18n } = props,
        loaded = useIsEventQuestionsLoaded(event.id),
        questions = useEventQuestions(event.id),
        question = useMemo(() => _(questions).maxBy('lastUpdateTimestamp'), [questions]);

    if (!isQAActive(event)) return null;

    return (
        <div className={['content', 'striped', styles.CommonEventQuests].join(' ')}>
            <SectionLinkedHeader href={['/events', event.id, 'qa'].join('/')} next color={event.settings.primary_color}>
                {i18n['label.questions']}
            </SectionLinkedHeader>
            {!loaded ? (
                <ListItem tagName="div" icon="/img/pixel.png" style={{}} iconStyle={{ backgroundSize: 'cover', backgroundColor: 'lightgray', borderRadius: '25px' }}>
                    <div style={{ backgroundColor: 'lightgray', height: '1em', marginBottom: '1ex' }}></div>
                    <div style={{ backgroundColor: 'lightgray', height: '1em', marginBottom: '1ex' }}></div>
                    <div style={{ backgroundColor: 'lightgray', height: '1em', marginBottom: '1ex' }}></div>
                </ListItem>
            ) : question ? (
                <Link href={['/events', event.id, 'qa', question.category_id || 'all', 'question', question.id].join('/')} key={question.id}>
                    <ListItem tagName="div" icon={question.asker.image_url} altIcon="img/no_avatar.png" style={{}} iconStyle={{ backgroundSize: 'cover', borderRadius: '25px' }}>
                        <div className="text main">{question.content.length > 256 ? question.content.substring(0, 255) + '...' : question.content}</div>
                    </ListItem>
                </Link>
            ) : (
                <Link href={['/events', event.id, 'qa'].join('/')}>
                    <ListItem tagName="div" icon="img/Icon.png" style={{}} iconStyle={{ backgroundSize: 'cover', borderRadius: '25px' }}>
                        <div className="text main">{i18n[event.data_type == 1 ? 'label.tip.no-questions-post' : 'label.tip.no-questions-post-community']}</div>
                    </ListItem>
                </Link>
            )}
        </div>
    );
};

export default CommonEventQuests;
